module.exports = __webpack_public_path__ + "img/лого_футера.1f45813c.png";